import { StatTable } from "components/StatsTable/StatTable";
import { TimeAttackSet } from "model/Match/Set/TimeAttack/TimeAttackSet";
import { anyStringContains } from "Utility";
import {
  calculateTeamSmsTimeAttackRecords,
  SmsTimeAttackRecordWithDisplay,
} from "model/Records old/TimeAttackSmsRecord";
import { getSmsTimeAttackRecordOverviewStatTableColumns } from "components/StatsTable/ColumnConfigs/RecordTable/SmsTimeAttackOverview";
import { MatchTeams } from "model/Match/MatchTeams";
import { getDefinedRosterIds } from "model/Roster/Roster";
import {
  selectRosterDisplayName,
  selectRosterOrgDetails,
} from "selectors/Roster";
import { selectTrackNameFromTournamentId } from "selectors/Tournament";
import { useAppSelector } from "app/hooks";

interface Props {
  set: TimeAttackSet;
  teams: MatchTeams;
  tournamentId: string;
}

export const SmsTimeAttackTeamTable = ({ set, teams, tournamentId }: Props) => {
  const trackNames = useAppSelector((state) => {
    const names = set.tracks.map((t) =>
      !!t.trackId
        ? selectTrackNameFromTournamentId(state, t.trackId, tournamentId)
        : undefined
    );
    while (names.length < set.format.numTracks) {
      names.push(undefined);
    }

    return names;
  });

  const records = calculateTeamSmsTimeAttackRecords(
    set,
    getDefinedRosterIds(teams.rosters)
  );

  const recordsWithDisplay: SmsTimeAttackRecordWithDisplay[] = useAppSelector(
    (state) =>
      records.map((r) => {
        const { id: orgId, name: orgName } =
          selectRosterOrgDetails(state, r.rosterId, tournamentId) || {};

        const displayName = selectRosterDisplayName(
          state,
          r.rosterId,
          tournamentId
        );

        return { record: r, orgId, displayName, orgName };
      })
  );

  const statTableColumns =
    getSmsTimeAttackRecordOverviewStatTableColumns(trackNames);

  return (
    <StatTable
      thinner={true}
      stats={recordsWithDisplay}
      columns={statTableColumns}
      keyGetter={(arg) => arg.displayName}
      paginationAmount={40}
      searchFunction={(arg, searchText) =>
        anyStringContains(
          searchText,
          arg.displayName,
          arg.orgName,
        )
      }
      searchPlaceholder="Filter: Org or Driver. Comma for multiple"
    />
  );
};
